import React from "react";
import "./SkillsLetter.styles.css";
const SkillsLetter = () => {
  return (
    <React.Fragment>
      <p className="skill react ">ReactJS</p>
      <p className="skill javascript">JavaScript</p>
      <p className="skill html">HTML5</p>
      <p className="skill css">Css</p>
    </React.Fragment>
  );
};

export default SkillsLetter;
